A question component of an `ApplicationQuestionnaire`.

This consists of identifiers for the library question and its preferred response choices.
